export { ColorSwatch as default } from './ColorSwatch';
